












import { Component , Vue } from 'vue-property-decorator';
@Component({
    props: {
        message: String,
    },
})
export default class ConfirmationBox extends Vue {

    private handleConfirm() {
        this.$emit('confirm');
    }

    private handleCancel() {
        this.$emit('cancel');
    }
}
